import React from 'react';
import { Box, Typography, Button, Grid, CircularProgress, Container, Alert } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { getMyProjects } from '../services/api';
import useFetch from '../hooks/useFetch';

import ProjectCard from '../components/ProjectCard';

const StudentDashboard = () => {
  const navigate = useNavigate();
  const { data, loading, error, execute } = useFetch(getMyProjects);
  
  const projects = data?.projects || [];

  const handleProjectDelete = () => {
    execute();
  };

  const handleProjectUpdate = () => {
    execute();
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Alert severity="error">Failed to load projects. Please try again later.</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1">
          My Projects
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/upload')}
        >
          Upload Project
        </Button>
      </Box>

      {projects.length === 0 ? (
        <Box sx={{ textAlign: 'center', mt: 8 }}>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            No projects found
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            {`You haven't uploaded any projects yet.`}
          </Typography>
          <Button 
            variant="outlined" 
            onClick={() => navigate('/upload')}
          >
            Upload Your First Project
          </Button>
        </Box>
      ) : (
        <Grid container spacing={3}>
          {projects.map((project) => (
            <Grid item key={project._id} xs={12} sm={6} md={4}>
              <ProjectCard project={project} onProjectUpdate={handleProjectUpdate} onProjectDelete={handleProjectDelete} />
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default StudentDashboard;
